import { createReducer } from '@ngrx/store';

import { GatewayState } from './gateway.state';

export const initGatewayState: GatewayState = {
  performing: false,
  performed: false,
  loading: false,
  loaded: false,
  error: null,
};

export const gatewayReducer = createReducer(initGatewayState);
